import { US_BRANDS, CA_BRANDS, ALL_BRANDS } from 'utils/domainHelper';
import { get } from 'lodash';

export const isSupportedModule = (document, brandName) => {
  let supportedBrands = get(document, 'fields.supportedBrands', 'All Brands');
  supportedBrands =
    supportedBrands === 'US Brands'
      ? US_BRANDS
      : supportedBrands === 'CA Brands'
      ? CA_BRANDS
      : ALL_BRANDS;
  supportedBrands = supportedBrands.map((brand) => brand.toLowerCase());
  return supportedBrands.includes(brandName.toLowerCase());
};
